import { State } from "./State";
export class QuestionOptions {
    constructor(options) {
        this.options = new State(options);
    }
    subscribe(sub) {
        return this.options.subscribe(sub);
    }
    addOption(option) {
        if (this.hasOption(option.id)) {
            return;
        }
        this.options.value.push(option);
        this.options.set();
    }
    quitAll() {
        this.options.set([]);
    }
    quitOption(optionId) {
        if (!this.hasOption(optionId)) {
            return;
        }
        const index = this.options.value.findIndex(({ id }) => id === optionId);
        this.options.value.splice(index, 1);
        this.options.set();
    }
    moveUp(optionId) {
        if (!this.hasOption(optionId)) {
            return;
        }
        const index = this.options.value.findIndex(({ id }) => id === optionId);
        if (index === 0) {
            return;
        }
        const [option] = this.options.value.splice(index, 1);
        this.options.value.splice(index - 1, 0, option);
        this.options.set();
    }
    moveDown(optionId) {
        if (!this.hasOption(optionId)) {
            return;
        }
        const index = this.options.value.findIndex(({ id }) => id === optionId);
        if (index === this.options.value.length - 1) {
            return;
        }
        const [option] = this.options.value.splice(index, 1);
        this.options.value.splice(index + 1, 0, option);
        this.options.set();
    }
    hasOption(optionId) {
        return this.options.value.some(({ id }) => id === optionId);
    }
    toJSON() {
        return [...this.options.value];
    }
}
